<template>
  <div class="bk-color" style="margin-top: 45px;" :style="{ paddingBottom: showMoreContent ? '0' : '12px' }">

    <v-row class="icoev-header-row fixNotchMarginTop fixNotchPaddingBottom" style="height: 100px; max-height: 100px;">
			<v-col cols="12" class="icoev-header-title">
				<h4>
					<v-icon color="primary" style="top: -2px;">mdi-email</v-icon>
					Newsletter
				</h4>
				<v-text-field 
					light solo flat
					class="search icoev-search-input"
					v-model="search"
					append-icon="mdi-magnify"
					label="Buscar..."
					:disabled="isLoading"
          @keyup="searchTimeOut()"/>
			</v-col>
    </v-row>

    <div class="icoev-main-content-wrapper fixNotchMarginTop fixNotchPaddingBottom" style="top: 105px;">

		<v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%"/>

		<v-alert v-if="!isLoading && items.length == 0" type="error" style="margin: 25px;">
			No se han encontrado datos
		</v-alert>

		<div v-for="(group, index) in groups" :key="index">			
      <h4 :id="'newsletter-group-' + index" class="primary--text pa-2">{{ group && group.length > 0 ? getYear(group[0].fecha) : '' }}</h4>
      <v-card outlined class="mx-auto" max-width="95%">
				<v-list v-if="!isLoading" style="padding: 0;">
					<div v-for="item in group" :key="item.id">
						<NewsletterItem :data="item" @open-external-content="openUrl(arguments)"/>
						<v-divider v-if="item.id != group[group.length-1].id"/>
					</div>
				</v-list>
			</v-card>
		</div>

		<v-row v-if="showMoreContent">
			<v-col style="text-align: center;">
				<a @click="addMoreContent()">Mostrar más contenido</a>
			</v-col>
		</v-row>
    </div>
  </div>

</template>

<script>
import api from '../../../api/icoev';
import BaseModule from "../../common/BaseModule";
import NewsletterItem from "../../common/NewsletterItem";

export default {
  name: 'NewsletterMain',
	mixins: [ BaseModule ],
	components: { 
		NewsletterItem
	},
	data () {
		return {
			isLoading: false,
			search: '',
			page: 0,
			items: [],
			groups: [],
			selector: null,
			showMoreContent: false,
			isDirty: true,
			lastUpdate: null,
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.$vue.$on('ne_awake', this.processAwake);
    });
	},
	methods: {
		processAwake: function(seconds) {
			this.$log.debug("NewsletterMain - processAwake: paused -> " + seconds + " secs");
			if (seconds > this.MAX_UPDATE_DELAY_IN_SECONDS) {
				//this.$log.debug("NewsletterMain - processAwake: paused > 10 secs -> dirty = true");
				this.isDirty = true;
			}
		},
		searchTimeOut() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
					this.page = 0;
					this.showMoreContent = false;
					this.items = [];

					this.listarItems();
			}, 800);
		},
		listarItems: function() {
			this.$log.debug("NewsletterMain - listarItems()");

			this.isLoading = true;

			this.groups = [];

			var me = this;

			api.getNewsletters(this.page, this.search ? this.search : '',
				res => {
					this.isLoading = false;

					if (!res.rsOK) {
						this.$emit('alert-event', { text: res.message, color: 'error', timeout: 3000 });
						return;
					}

					this.lastUpdate = new Date();

					if (res.entities.length == 0) {
						return;
					}
				
					this.items.push(...res.entities);

					this.showMoreContent = res.hasMoreData;

					if (this.selector) {
						this.$nextTick(() => {
							var anchor = this.$el.querySelector(this.selector);
							if (anchor) {
								anchor.scrollIntoView();
							}
						});
					}

					this.items.forEach(function (a) {
						var year = me.getYear(a.fecha);
						this[year] || me.groups.push(this[year] = []);
						this[year].push(a);
					}, Object.create(null));
				},
				err => {               
					this.isLoading = false;     
					this.$log.error(err);
					this.$emit('alert-event', { text: 'Error al actualizar las noticias', color: 'error', timeout: 3000 });
				}
			);
		},
		addMoreContent: function() {
			this.page++;
			this.selector = '#newsletter' + this.items[this.items.length - 1].id;
			this.showMoreContent = false;
			
			this.listarItems();
		},			
		getYear: function(date) {
				var year = date.split(" ")[0].split("/")[2];
				return parseInt(year);
		},
		onlyUnique: function(value, index, self) {
			return self.indexOf(value) === index;
		},
		openUrl: function(args) {
			this.$emit('open-external-content', args[0], args[1]);
		},
		reset() {
			this.page = 0;
			this.items = [];
			this.selector = '#newsletter-group-0';
			this.showMoreContent = false;
			this.isDirty = true;
		}
	},
	computed: {
		userChanged() {
			return this.$store.state.icoev.user;
		}
	},
	watch: {
		userChanged() {
			this.reset();
		},
		// eslint-disable-next-line no-unused-vars
		/*$route (to, from) {
			if (to.name !== 'newsletter') {
				return;
			}

			//this.$log.debug("NewsletterMain - to.params.redirect: " + to.params.redirect);	
			if (to.params.redirect) {
				to.params.redirect = false;
				//this.$log.debug("NewsletterMain - clearCache()");
				api.clearNewslettersCache();
				//this.$log.debug("NewsletterMain - reset()");
				this.reset();
			}
			//this.$log.debug("NewsletterMain - isDirty: " + this.isDirty);
			if (this.isDirty) {	
				this.isDirty = false;			
				this.$nextTick(() => {
					this.listarItems();
        });
				//this.$log.debug("NewsletterMain - isDirty: " + this.isDirty);
			}
		},*/
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (to.name !== 'newsletter') {
				return;
			}
			
			if (vm.needsUpdate(vm.lastUpdate)) {
				vm.reset();
			}

			//vm.$log.debug("NewsletterMain - to.params.redirect: " + to.params.redirect);
			if (to.params.redirect) {
				to.params.redirect = false;
				//vm.$log.debug("NewsletterMain - clearCache()");
				api.clearNewslettersCache();
				//vm.$log.debug("NewsletterMain - reset()");
				vm.reset();
			}
			//vm.$log.debug("NewsletterMain - isDirty: " + vm.isDirty);
			if (vm.isDirty) {
				vm.isDirty = false;
				vm.$nextTick(() => {
					vm.listarItems();
        });
				//vm.$log.debug("NewsletterMain - isDirty: " + vm.isDirty);
			}
		})
	},
}
</script>